"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconPerson', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,17 L3.998,17 L3.997,16.076 C4.271,12.499 6.738,10 10,10 C13.25,10 15.713,12.481 16,16.039 L16,17 Z M7.5,5.5 C7.5,4.121 8.621,3 10,3 C11.379,3 12.5,4.121 12.5,5.5 C12.5,6.879 11.379,8 10,8 C8.621,8 7.5,6.879 7.5,5.5 Z M17.997,15.924 C17.735,12.495 15.887,9.832 13.199,8.658 C14.002,7.846 14.5,6.73 14.5,5.5 C14.5,3.019 12.481,1 10,1 C7.519,1 5.5,3.019 5.5,5.5 C5.5,6.73 5.998,7.846 6.802,8.659 C4.114,9.837 2.264,12.516 2,16 L2,18 C2,18.553 2.447,19 3,19 L17,19 C17.553,19 18,18.553 18,18 L18,16 C18,15.975 17.999,15.949 17.997,15.924 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;